import { render } from "./ClosedObligationsItem.vue?vue&type=template&id=5629199d&scoped=true&ts=true"
import script from "./ClosedObligationsItem.vue?vue&type=script&lang=ts"
export * from "./ClosedObligationsItem.vue?vue&type=script&lang=ts"

import "./ClosedObligationsItem.vue?vue&type=style&index=0&id=5629199d&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5629199d"]])

export default __exports__